import React from 'react'
import './StoreStyles.css'
import Soon from '../assets/comingsoon.jpg'
function Store() {
  return (
    <div>
        <div className='container'>
            <article className='store-item'>
                <div className='item-image'>
                   <img src={Soon}></img>
                </div>
                <h3>Shirt</h3>
                <p>$39.99</p>
                <a href='' className='btn' target=''>Buy</a>
            </article>
            <article className='store-item'>
                <div className='item-image'>
                   <img src={Soon}></img>
                </div>
                <h3>Shirt</h3>
                <p>$39.99</p>
                <a href='' className='btn' target=''>Buy</a>
            </article>
            <article className='store-item'>
                <div className='item-image'>
                   <img src={Soon}></img>
                </div>
                <h3>Shirt</h3>
                <p>$39.99</p>
                <a href='' className='btn' target=''>Buy</a>
            </article>
            <article className='store-item'>
                <div className='item-image'>
                   <img src={Soon}></img>
                </div>
                <h3>Shirt</h3>
                <p>$39.99</p>
                <a href='' className='btn' target=''>Buy</a>
            </article>
            <article className='store-item'>
                <div className='item-image'>
                   <img src={Soon}></img>
                </div>
                <h3>Shirt</h3>
                <p>$39.99</p>
                <a href='' className='btn' target=''>Buy</a>
            </article>
            <article className='store-item'>
                <div className='item-image'>
                   <img src={Soon}></img>
                </div>
                <h3>Shirt</h3>
                <p>$39.99</p>
                <a href='' className='btn' target=''>Buy</a>
            </article>
        </div>
    </div>
  )
}

export default Store